import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorWrapper } from './ErrorWrapper'
import { logError } from '@/utils/errorLogger'

interface ErrorHandlerProps {
  errorType: string
}

export const ErrorHandler: React.FC<ErrorHandlerProps> = ({ errorType }) => {
  const { t } = useTranslation('errors')

  const getErrorType = (type: string): string => {
    const validErrorTypes = ['400', '404', '500']
    return validErrorTypes.includes(type) ? type : 'default'
  }

  const actualErrorType = getErrorType(errorType)

  useEffect(() => {
    const metadata = {
      ip: window.location.hostname, // En un entorno real, obtendrías esto del servidor
      date: new Date().toISOString(),
      id: `ERR${actualErrorType}-${Date.now()}`
    }
    logError(actualErrorType, metadata)
  }, [actualErrorType])

  return (
    <ErrorWrapper
      title={t(`${actualErrorType}.title`)}
      errorCode={actualErrorType === 'default' ? 'Unknown' : actualErrorType}
      subtitle={t(`${actualErrorType}.subtitle`)}
      description={t(`${actualErrorType}.description`)}
    >
      <p>{t(`${actualErrorType}.text`)}</p>
    </ErrorWrapper>
  )
}
